import { Download, Edit, Trash2 } from "react-feather";
import { Link } from "react-router-dom";
import {
  ButtonGroup,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { admins, timeToast } from "../../../Constant";
import { FEATURE_FUNCTION_SELECTION } from "../../../Constant/FeatureSelection";
import {
  BaruDiajukan,
  canAccessWhenStatus,
  DipertanggungJawabkan,
  getStatusData,
  STATUS_DATA_TYPE,
} from "../../../Constant/StatusData";
import {
  formatDate,
  formatRP,
  getUser,
} from "../../../Utils/externalFunctions";
import { getDarkDropdown, getStatusBadge } from "../../../Utils/otherFunctions";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import DateSortFunction from "../../DataTableComponents/DateSortFunction";
import { toast } from "react-toastify";
import { getItemCreateSuccessMsg } from "../../../Constant/Message";

const getTransaksiColumns = ({
  themeContext,
  handleEditStatusTransaksi,
  handleDeleteTransaksi,
  axiosInstance
}) => {

  const cetakFPA = async (id) => {
    try {
      const res = await axiosInstance.get(`transaksi/cetak/${id}`, {
        responseType: "blob",
      });
      const file = new Blob([res.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      const newTab = window.open(fileURL, "_blank");
      if (!newTab) {
        console.error("Popup blocked. Please allow popups for this website.");  
      }
      toast.success(getItemCreateSuccessMsg("FPA"), {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    } catch (e) {
      console.error(e);
    }
  };

  const columns = [
    {
      name: <DataTableTitle text={"PK"} />,
      selector: (row) => row.id,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Kode Transaksi"} />,
      selector: (row) => row.id_transaksi,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Tanggal Transaksi"} />,
      selector: (row) => formatDate(row.tanggal_transaksi),
      sortable: true,
      sortFunction: DateSortFunction("tanggal_transaksi"),
    },
    {
      name: <DataTableTitle text={"Diajukan Oleh"} />,
      selector: (row) => row.diajukan_oleh,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Keterangan"} />,
      selector: (row) => row.keterangan,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Dibayar Ke"} />,
      selector: (row) => row.dibayarkan_ke,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Nilai (Rp)"} />,
      selector: (row) => parseInt(row.nilai_transaksi),
      sortable: true,
      format: (row) => formatRP(row.nilai_transaksi),
    },
    {
      name: <DataTableTitle text={"Jenis Pembayaran"} />,
      selector: (row) => row.kode_jenis_pembayaran,
      sortable: true,
    },
    {
      name: <DataTableTitle text={"Status"} />,
      selector: (row) => {
        const statusData = getStatusData(
          row.id_status_transaksi,
          STATUS_DATA_TYPE.Transaksi
        );
        return getStatusBadge(statusData);
      },
      sortable: true,
    },
  ];

  FEATURE_FUNCTION_SELECTION.Transaksi.Operasi &&
    columns.push({
      name: <DataTableTitle text={"Operasi"} />,
      cell: (row) => {
        const canAccess = canAccessWhenStatus(
          row.id_status_transaksi,
          STATUS_DATA_TYPE.Transaksi,
          [BaruDiajukan, DipertanggungJawabkan]
        );
        return (
          <ButtonGroup>
            <UncontrolledDropdown>
              <DropdownToggle caret></DropdownToggle>
              <DropdownMenu>
                {(canAccess || admins.includes(getUser())) &&
                  FEATURE_FUNCTION_SELECTION.Transaksi.Update && (
                    <>
                      <Link
                        to={`${process.env.PUBLIC_URL}/transaksi/edit/${row.id}`}
                      >
                        <DropdownItem
                          className={`d-flex align-items-center gap-2 ${getDarkDropdown(
                            themeContext
                          )}`}
                        >
                          <Edit size={12} />
                          Ubah
                        </DropdownItem>
                      </Link>
                      <DropdownItem divider />
                    </>
                  )}

                {FEATURE_FUNCTION_SELECTION.Transaksi.UpdateStatus &&
                  admins.includes(getUser()) && (
                    <>
                      <DropdownItem
                        className={`d-flex align-items-center gap-2 ${getDarkDropdown(
                          themeContext
                        )}`}
                        onClick={() => handleEditStatusTransaksi(row)}
                      >
                        <Edit size={12} />
                        Edit Status
                      </DropdownItem>
                      <DropdownItem divider />
                    </>
                  )}

                {(canAccess || admins.includes(getUser())) &&
                  FEATURE_FUNCTION_SELECTION.Transaksi.Delete && (
                    <>
                      <DropdownItem
                        className={`text-danger d-flex align-items-center gap-2 ${getDarkDropdown(
                          themeContext
                        )}`}
                        onClick={() => handleDeleteTransaksi(row)}
                      >
                        <Trash2 size={12} />
                        Hapus
                      </DropdownItem>
                      <DropdownItem divider />
                    </>
                  )}

                {FEATURE_FUNCTION_SELECTION.Transaksi.CetakLaporan && (
                  // <DropdownItem className={getDarkDropdown(themeContext)}>
                  //   <Link
                  //     className={`d-flex align-items-center gap-2`}
                  //     to={`${process.env.PUBLIC_URL}/transaksi/document/${row.id}`}
                  //     target="_blank"
                  //   >
                  //     <Download size={12} />
                  //     Cetak Laporan
                  //   </Link>
                  // </DropdownItem>
                  <DropdownItem className={` ${getDarkDropdown(themeContext)} d-flex align-items-center gap-2`} onClick={() => cetakFPA(row.id)}>
                    <Download size={12} />
                    Cetak Laporan
                  </DropdownItem>
                )}
              </DropdownMenu>
            </UncontrolledDropdown>
          </ButtonGroup>
        );
      },
    });

  return columns;
};

export default getTransaksiColumns;
